import { Row, Col, Button, Alert } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { TextField, Label } from 'components';
import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { initiateAskTempPasswordFlow } from 'store/user/actions';
import { types } from 'store/user/types';
import { types as formTypes } from 'store/form/types';
import keycloak from 'Keycloak.js';

const ForgotPasswordPage = () => {
  const dispatch = useDispatch();
  const params =  useSelector(state => state.user);
  const initiated =  useSelector(state => state.form.initiated);
  const hasError =  useSelector(state => state.form.hasError);
  const loading =  useSelector(state => state.form.loading);
  const message =  useSelector(state => state.form.message);
  const inputRef = useRef(null);
  const submitClicked = (e) => {
    dispatch(initiateAskTempPasswordFlow(params));
  };
  useEffect(() => { 
    dispatch({ type: types.RESET_USER });
    dispatch({ type: formTypes.RESET_FORM });
    keycloak.tracker.invalidateUserForAuthPages(true, () => {
      dispatch({ type: formTypes.SET_FORM_INITIATED });
    }); 
  }, []);
  useEffect(() => {
    initiated && inputRef.current.focus();
  }, [initiated]);
  return (
    initiated &&
    <div className="forgotpass-page">
      <Row className="page-title-row forgotpass-title-row">
        <Col span={24} className="page-title-col forgotpass-title-col">
          <Label
            label="Ξεχάσατε τον Κωδικό σας;"
            labelClassName="page-title-label forgotpass-title-label"
          />
        </Col>
      </Row>
      <Row className="error-wrapper-row">
        <Col span={24} className="error-wrapper-col">
          {hasError && <Alert
            message="Σφάλμα"
            description={message}
            className="error-component"
            type="error"
            icon={<ExclamationCircleFilled />}
            closable
            showIcon
          />}
        </Col>
      </Row>
      <Row className="userpass-wrapper-row">
        <Col span={24} className="userpass-wrapper-col">
          <TextField
            className="username-component"
            labelClassName="userpass-label username-label"
            containerClassName="username-container"
            fieldName="username"
            fieldType="text"
            label="Email"
            size="large"
            placeholder="Εισάγετε email"
            disabled={loading}
            customRef={inputRef}
            onPressEnter={submitClicked}
          />
        </Col>
      </Row>
      <Row className="backto-login-row">
        <Col span={24} className="backto-login-col">
          <Link
            className="backto-login-component"
            to="/login"
             >Πίσω στην είσοδο</Link>
        </Col>
      </Row>
      <Row className="buttons-wrapper-row">
        <Col span={24} className="buttons-wrapper-col">
          <Button
            type="primary"
            className="submit-component"
            disabled={loading}
            onClick={submitClicked}
            >Υποβολή</Button>
        </Col>
      </Row>
      <Row className="footer-title-row">
        <Col span={24} className="footer-title-col">
          <Label
            label="Εισάγετε το email σας και θα σας στείλουμε οδηγίες δημιουργίας νέου κωδικού."
            labelClassName="footer-title-label"
          />
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordPage;
